import { helper } from '@ember/component/helper';
import dayjs from 'dayjs';

export default helper(function formatDate(params/*, hash*/)
{
	let value = params[0];
	let format = params[1];

	// Return empty string for null, undefined, or empty string values
	if (value == null || value === '') {
		return '';
	}

	// Handle milliseconds format (.SSS) - dayjs supports this natively
	if (format && format.includes('.SSS')) {
		return dayjs(value).format(format);
	}

	// Handle custom tenths of second format (.S)
	// This is for single .S only, not .SS or .SSS
	if (format && format.includes('.S')) {
		const dayjsObj = dayjs(value);
		// Get milliseconds and convert to tenths (divide by 100)
		const tenths = Math.floor(dayjsObj.millisecond() / 100);
		// Format without the .S part
		const baseFormat = format.replace('.S', '');
		const formatted = dayjsObj.format(baseFormat);
		return formatted + '.' + tenths;
	}

	// Format the date using dayjs
	return dayjs(value).format(format);
});
